import styled from 'foundations-theming/utils';
const Whitespace = styled.div.withConfig({
  displayName: "Whitespace",
  componentId: "sc-1gqilrz-0"
})(["height:", "px;"], ({
  height
}) => height);
export default Whitespace;